import React, { useEffect, useRef, useState } from 'react';

/** Fade/slide-in when section enters viewport (scroll experience). */
export default function MarketplaceReveal({ children, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`mh-reveal ${visible ? 'mh-reveal--visible' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
}
